// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../../fetch.pb.js";
export const EmailProviderSGService = {
    /**
     * AuthenticateDomain creates a domain record with Sendgrid. DNS
     * records are generated and returned in the response to be added
     * to the domain's DNS server.
     */
    AuthenticateDomain(fn, req) {
        return fn(`/email/provider/sg/v1/domain/authenticate`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ValidateDomain validates that the DNS records have been
     * successfully added to the domain's DNS server and updates the
     * domain record with Sendgrid. The domain record will need to be
     * marked as valid with Sendgrid before it can be used to send emails.
     */
    ValidateDomain(fn, req) {
        try {
            fm.validateUrlParam(req["domainId"], "domainId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/email/provider/sg/v1/domain/${req["domainId"]}/validate`, { method: "POST" });
    },
    /**
     * DeleteDomain deletes the domain record with Sendgrid.
     */
    DeleteDomain(fn, req) {
        try {
            fm.validateUrlParam(req["domainId"], "domainId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/email/provider/sg/v1/domain/${req["domainId"]}?${fm.renderURLSearchParams(req, ["domainId"])}`, { method: "DELETE" });
    },
    /**
     * GetDomain retrieves the domain record saved with Sendgrid.
     */
    GetDomain(fn, req) {
        try {
            fm.validateUrlParam(req["domainId"], "domainId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/email/provider/sg/v1/domain/${req["domainId"]}?${fm.renderURLSearchParams(req, ["domainId"])}`, { method: "GET" });
    },
};
